"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertEventType = void 0;
/**
 * Function that asserts that a given event matches one of the included types.
 * Throws an error if the event type does not match.
 * @param {TE} event an event or object returned from an event
 * @param {...TType} eventTypes list of acceptable event types
 *
 */
function assertEventType(event, ...eventTypes) {
    if (!eventTypes.includes(event.type)) {
        throw new Error(`Invalid event: expected one of ["${eventTypes.join('", "')}"], got "${event.type}"`);
    }
}
exports.assertEventType = assertEventType;
//# sourceMappingURL=assertEventType.js.map